import { SentryService, SentryEnvironment } from '@travelata-libs/utils';

declare const SENTRY_DSN: string;
declare const SENTRY_ENVIRONMENT: SentryEnvironment;

//доля трассируемых запросов (только 10% трассировок логируется в sentry) ошибки не смотрят на этот параметр и логируются все
const sentryService = new SentryService({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    tracesSampleRate: 0.001, 
});

export default sentryService;
